var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "nativewind/jsx-runtime";
/* eslint-disable no-restricted-imports --
   편집 모드 전용 사이드바(운영자만 사용) — 계측 대상이 아니다.
   (터치 컴포넌트는 Scc* 사용 원칙: .eslintrc.js no-restricted-imports) */
import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { View, Text, TouchableOpacity, TextInput, ScrollView, Image } from 'react-native';
import styled from 'styled-components/native';
import { useEditMode } from '../context/EditModeContext';
import { apiConfig } from '../../../config/api';
import { color } from '@/constant/color';
import ImageUploader from '../components/ImageUploader';
import RegionDetailModal from '../components/RegionDetailModal';
import { loginWithKakao, logoutFromKakao } from '../../../utils/kakaoAuth';
export default function EditSidebar() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const editContext = useEditMode();
    const [jsonInput, setJsonInput] = useState('');
    const [importError, setImportError] = useState(null);
    const [copySuccess, setCopySuccess] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [loginError, setLoginError] = useState(null);
    const [userName, setUserName] = useState(null);
    const [previewImageUrl, setPreviewImageUrl] = useState(null);
    // 이미지 프리뷰용 fake region 객체 생성
    const previewRegion = useMemo(() => {
        if (!previewImageUrl)
            return null;
        return {
            id: 'preview',
            polygon: [],
            modalImageUrls: [previewImageUrl],
        };
    }, [previewImageUrl]);
    // Check login status on mount
    useEffect(() => {
        const storedToken = window.localStorage.getItem('sccAccessToken');
        const storedUserName = window.localStorage.getItem('sccUserName');
        if (storedToken) {
            setIsLoggedIn(true);
            setUserName(storedUserName);
            apiConfig.accessToken = storedToken;
        }
    }, []);
    const handleKakaoLogin = useCallback(() => {
        var _a;
        setLoginError(null);
        const result = loginWithKakao();
        if (!result.ok) {
            setLoginError((_a = result.error) !== null && _a !== void 0 ? _a : '로그인을 시작하지 못했습니다.');
        }
    }, []);
    const handleLogout = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        yield logoutFromKakao();
        setIsLoggedIn(false);
        setUserName(null);
        setLoginError(null);
    }), []);
    // hook 은 early return 앞에서 무조건 호출한다 (react-hooks/rules-of-hooks).
    const exportToJson = editContext === null || editContext === void 0 ? void 0 : editContext.exportToJson;
    const importFromJson = editContext === null || editContext === void 0 ? void 0 : editContext.importFromJson;
    const handleExportJson = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        if (!exportToJson)
            return;
        const json = exportToJson();
        try {
            yield navigator.clipboard.writeText(json);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
        }
        catch (error) {
            console.error('Failed to copy to clipboard:', error);
        }
    }), [exportToJson]);
    const handleImportJson = useCallback(() => {
        if (!importFromJson)
            return;
        setImportError(null);
        const success = importFromJson(jsonInput);
        if (success) {
            setJsonInput('');
        }
        else {
            setImportError('JSON 파싱 실패. 올바른 형식인지 확인하세요.');
        }
    }, [jsonInput, importFromJson]);
    if (!editContext)
        return null;
    const { data, updateData, editingRegion, startAddingRegion, startAddingSeatViewRegion, startEditingRegion, startEditingSeatViewRegion, addModalImageToRegion, removeModalImageFromRegion, clearRegionPoints, undoRegionPoint, saveEditingRegion, cancelEditingRegion, deleteRegion, deleteSeatViewRegion, } = editContext;
    return (_jsxs(Container, { children: [_jsx(ScrollView, { children: _jsxs(SidebarContent, { children: [_jsxs(Header, { children: [_jsx(HeaderTitle, { children: "Edit Mode" }), _jsx(EditBadge, { children: _jsx(EditBadgeText, { children: "\uD3B8\uC9D1 \uC911" }) })] }), _jsxs(Section, { children: [_jsx(SectionTitle, { children: "\uC778\uC99D" }), isLoggedIn ? (_jsxs(_Fragment, { children: [_jsxs(LoginStatusRow, { children: [_jsx(LoginStatusIcon, { children: "\u2713" }), _jsx(LoginStatusText, { children: userName || '로그인됨' })] }), _jsx(LogoutButton, { onPress: handleLogout, children: _jsx(LogoutButtonText, { children: "\uB85C\uADF8\uC544\uC6C3" }) })] })) : (_jsxs(_Fragment, { children: [_jsxs(LoginStatusRow, { children: [_jsx(LoginStatusIcon, { style: { color: '#dc3545' }, children: "!" }), _jsx(LoginStatusText, { style: { color: '#dc3545' }, children: "\uB85C\uADF8\uC778 \uD544\uC694 (\uC774\uBBF8\uC9C0 \uC5C5\uB85C\uB4DC\uC6A9)" })] }), loginError && _jsx(ErrorText, { children: loginError }), _jsx(KakaoLoginButton, { onPress: handleKakaoLogin, children: _jsx(KakaoLoginButtonText, { children: "\uCE74\uCE74\uC624\uB85C \uB85C\uADF8\uC778" }) })] }))] }), _jsxs(Section, { children: [_jsx(SectionTitle, { children: "\uD604\uC7AC \uB370\uC774\uD130" }), _jsxs(InfoRow, { children: [_jsx(InfoLabel, { children: "ID:" }), _jsx(InfoValue, { children: data.id || '(없음)' })] }), _jsxs(InfoRow, { children: [_jsx(InfoLabel, { children: "\uC81C\uBAA9:" }), _jsx(InfoValue, { children: data.title || '(없음)' })] }), _jsxs(InfoRow, { children: [_jsx(InfoLabel, { children: "\uC139\uC158 \uC218:" }), _jsx(InfoValue, { children: data.sections.length })] }), _jsxs(InfoRow, { children: [_jsx(InfoLabel, { children: "\uB3D9\uC120 \uD0ED:" }), _jsxs(InfoValue, { children: [((_a = data.routeSection) === null || _a === void 0 ? void 0 : _a.routes.length) || 0, "\uAC1C"] })] })] }), _jsxs(Section, { children: [_jsx(SectionTitle, { children: "\uD5E4\uB354 \uC139\uC158" }), _jsxs(HeaderEditPanel, { children: [_jsxs(FieldGroup, { children: [_jsx(FieldLabel, { children: "\uCD5C\uC885 \uC5C5\uB370\uC774\uD2B8" }), _jsx(FieldInput, { value: data.lastUpdatedDate || '', onChangeText: (text) => updateData((prev) => (Object.assign(Object.assign({}, prev), { lastUpdatedDate: text }))), placeholder: "\uC608: \uCD5C\uC885 \uC5C5\uB370\uC774\uD2B8 2025.12.05", placeholderTextColor: "#999" })] }), _jsxs(FieldGroup, { children: [_jsx(FieldLabel, { children: "\uC811\uADFC\uC131 \uD55C\uB9C8\uB514 (HTML) - \uB370\uC2A4\uD06C\uD0D1" }), _jsx(HtmlTextAreaSmall, { multiline: true, value: data.wheelchairUserCommentHtml || '', onChangeText: (text) => updateData((prev) => (Object.assign(Object.assign({}, prev), { wheelchairUserCommentHtml: text }))), placeholder: "<b>\uBCFC\uB4DC \uD14D\uC2A4\uD2B8</b> \uC77C\uBC18 \uD14D\uC2A4\uD2B8...", placeholderTextColor: "#999" })] }), _jsxs(FieldGroup, { children: [_jsx(FieldLabel, { children: "\uC811\uADFC\uC131 \uD55C\uB9C8\uB514 (HTML) - \uBAA8\uBC14\uC77C" }), _jsx(HtmlTextAreaSmall, { multiline: true, value: data.wheelchairUserCommentHtmlMobile || '', onChangeText: (text) => updateData((prev) => (Object.assign(Object.assign({}, prev), { wheelchairUserCommentHtmlMobile: text }))), placeholder: "\uBAA8\uBC14\uC77C\uC6A9 \uC904\uBC14\uAFC8 \uB2E4\uB974\uAC8C...", placeholderTextColor: "#999" })] }), _jsxs(FieldGroup, { children: [_jsx(FieldLabel, { children: "\uBAA8\uBC14\uC77C \uD0C0\uC774\uD2C0 \uC774\uBBF8\uC9C0 (@2x)" }), data.mobileTitleImageUrl ? (_jsxs(ImagePreviewContainer, { children: [_jsx(ImagePreview, { source: { uri: data.mobileTitleImageUrl } }), _jsx(ImageRemoveButton, { onPress: () => updateData((prev) => (Object.assign(Object.assign({}, prev), { mobileTitleImageUrl: undefined }))), children: _jsx(ImageRemoveButtonText, { children: "\u00D7" }) })] })) : (_jsx(ImageUploader, { onUploadComplete: (url) => updateData((prev) => (Object.assign(Object.assign({}, prev), { mobileTitleImageUrl: url }))), buttonText: "\uBAA8\uBC14\uC77C \uD0C0\uC774\uD2C0 \uC774\uBBF8\uC9C0 \uC5C5\uB85C\uB4DC" }))] }), _jsxs(FieldGroup, { children: [_jsx(FieldLabel, { children: "\uBAA8\uBC14\uC77C \uBC30\uACBD \uC774\uBBF8\uC9C0 (@2x)" }), data.mobileHeaderBackgroundImageUrl ? (_jsxs(ImagePreviewContainer, { children: [_jsx(ImagePreview, { source: { uri: data.mobileHeaderBackgroundImageUrl } }), _jsx(ImageRemoveButton, { onPress: () => updateData((prev) => (Object.assign(Object.assign({}, prev), { mobileHeaderBackgroundImageUrl: undefined }))), children: _jsx(ImageRemoveButtonText, { children: "\u00D7" }) })] })) : (_jsx(ImageUploader, { onUploadComplete: (url) => updateData((prev) => (Object.assign(Object.assign({}, prev), { mobileHeaderBackgroundImageUrl: url }))), buttonText: "\uBAA8\uBC14\uC77C \uBC30\uACBD \uC774\uBBF8\uC9C0 \uC5C5\uB85C\uB4DC" }))] }), _jsxs(FieldGroup, { children: [_jsx(FieldLabel, { children: "\uBC30\uACBD \uC774\uBBF8\uC9C0 \uCEA1\uC158" }), _jsx(FieldInput, { value: data.headerImageCaption || '', onChangeText: (text) => updateData((prev) => (Object.assign(Object.assign({}, prev), { headerImageCaption: text }))), placeholder: "\uC608: *\uD50C\uB808\uC774\uBE0C \uCF58\uC11C\uD2B8 \uC0AC\uC9C4", placeholderTextColor: color.gray40 })] }), _jsxs(FieldGroup, { children: [_jsx(FieldLabel, { children: "\uACF5\uC720 \uBBF8\uB9AC\uBCF4\uAE30 \uC774\uBBF8\uC9C0 (OG)" }), _jsx(ImageUploader, { currentImageUrl: data.ogImageUrl, onUploadComplete: (url) => updateData((prev) => (Object.assign(Object.assign({}, prev), { ogImageUrl: url }))) }), data.ogImageUrl && (_jsx(OgImagePreview, { children: _jsx(OgImagePreviewImg, { source: { uri: data.ogImageUrl }, resizeMode: "contain" }) }))] })] })] }), _jsxs(Section, { children: [_jsx(SectionTitle, { children: "Region \uD3B8\uC9D1" }), editingRegion ? (
                                // 편집 중인 region 컨트롤
                                _jsxs(RegionEditPanel, { children: [_jsxs(RegionEditHeader, { children: [_jsx(RegionEditTitle, { children: editingRegion.regionIndex !== null
                                                        ? `Region #${editingRegion.regionIndex + 1} 편집`
                                                        : '새 Region 추가' }), _jsxs(RegionRouteTag, { children: ["Route #", editingRegion.routeIndex + 1] })] }), _jsx(RegionEditInfo, { children: _jsxs(InfoRow, { children: [_jsx(InfoLabel, { children: "\uC810 \uAC1C\uC218:" }), _jsxs(InfoValue, { children: [editingRegion.points.length, "\uAC1C"] })] }) }), _jsxs(RegionEditActions, { children: [_jsx(SmallButton, { onPress: clearRegionPoints, children: _jsx(SmallButtonText, { children: "\uCD08\uAE30\uD654" }) }), _jsx(SmallButton, { onPress: undoRegionPoint, disabled: editingRegion.pointsUndoStack.length === 0, style: {
                                                        opacity: editingRegion.pointsUndoStack.length > 0 ? 1 : 0.5,
                                                    }, children: _jsx(SmallButtonText, { children: "\u2318Z \uC2E4\uD589\uCDE8\uC18C" }) })] }), _jsxs(ModalImageSection, { children: [_jsxs(ModalImageLabel, { children: ["\uD074\uB9AD \uC2DC \uD45C\uC2DC\uD560 \uC774\uBBF8\uC9C0 (", editingRegion.modalImageUrls.length, "\uAC1C)"] }), _jsxs(ModalImageList, { children: [editingRegion.modalImageUrls.map((url, index) => (_jsxs(ModalImageItem, { children: [_jsx(TouchableOpacity, { onPress: () => setPreviewImageUrl(url), children: _jsx(ModalImagePreview, { source: { uri: url } }) }), _jsx(ModalImageRemove, { onPress: () => removeModalImageFromRegion(index), children: _jsx(ModalImageRemoveText, { children: "\u00D7" }) })] }, index))), _jsx(AddModalImageWrapper, { children: _jsx(ImageUploader, { onUploadComplete: addModalImageToRegion, buttonText: "+", compact: true }) })] })] }), _jsxs(RegionEditButtons, { children: [_jsx(CancelButton, { onPress: cancelEditingRegion, children: _jsx(CancelButtonText, { children: "\uCDE8\uC18C" }) }), _jsx(SaveButton, { onPress: saveEditingRegion, disabled: editingRegion.points.length < 3, style: {
                                                        opacity: editingRegion.points.length >= 3 ? 1 : 0.5,
                                                    }, children: _jsx(SaveButtonText, { children: "\uC800\uC7A5" }) })] })] })) : (
                                // Region 목록
                                _jsx(_Fragment, { children: (_b = data.routeSection) === null || _b === void 0 ? void 0 : _b.routes.map((route, routeIndex) => {
                                        var _a;
                                        const regions = ((_a = route.interactiveImage) === null || _a === void 0 ? void 0 : _a.clickableRegions) || [];
                                        if (!route.interactiveImage)
                                            return null;
                                        return (_jsxs(RouteRegionSection, { children: [_jsxs(RouteRegionHeader, { children: [_jsx(RouteRegionTitle, { children: route.tabLabel || `Route #${routeIndex + 1}` }), _jsx(AddRegionButton, { onPress: () => startAddingRegion(routeIndex), children: _jsx(AddRegionButtonText, { children: "+ Region" }) })] }), regions.length > 0 ? (regions.map((region, regionIndex) => {
                                                    var _a, _b, _c;
                                                    return (_jsxs(RegionListItem, { children: [_jsxs(RegionListHeader, { children: [_jsxs(RegionListInfo, { children: [_jsxs(RegionListIndex, { children: ["#", regionIndex + 1] }), _jsxs(RegionListDetail, { children: ["\uC810 ", region.polygon.length, "\uAC1C"] })] }), _jsxs(RegionListActions, { children: [_jsx(RegionEditButton, { onPress: () => startEditingRegion(routeIndex, regionIndex, region.polygon, region.modalImageUrls || []), children: _jsx(RegionEditButtonText, { children: "\uD3B8\uC9D1" }) }), _jsx(RegionDeleteButton, { onPress: () => deleteRegion(routeIndex, regionIndex), children: _jsx(RegionDeleteButtonText, { children: "\u00D7" }) })] })] }), ((_b = (_a = region.modalImageUrls) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 && (_jsx(RegionImageList, { children: (_c = region.modalImageUrls) === null || _c === void 0 ? void 0 : _c.map((url, imgIndex) => (_jsx(TouchableOpacity, { onPress: () => setPreviewImageUrl(url), children: _jsx(RegionImageThumb, { source: { uri: url } }) }, imgIndex))) }))] }, region.id));
                                                })) : (_jsx(NoRegionsText, { children: "Region \uC5C6\uC74C" }))] }, routeIndex));
                                    }) }))] }), ((_c = data.routeSection) === null || _c === void 0 ? void 0 : _c.routes) && data.routeSection.routes.length > 0 && (_jsxs(Section, { children: [_jsx(SectionTitle, { children: "\uB3D9\uC120 \uC124\uBA85 HTML" }), data.routeSection.routes.map((route, routeIndex) => {
                                    var _a;
                                    return (_jsxs(RouteHtmlEditPanel, { children: [_jsx(RouteHtmlHeader, { children: _jsx(RouteHtmlTitle, { children: route.tabLabel || `Route #${routeIndex + 1}` }) }), _jsx(HtmlTextArea, { multiline: true, value: route.descriptionHtml || '', onChangeText: (text) => updateData((prev) => (Object.assign(Object.assign({}, prev), { routeSection: prev.routeSection
                                                        ? Object.assign(Object.assign({}, prev.routeSection), { routes: prev.routeSection.routes.map((r, i) => i === routeIndex
                                                                ? Object.assign(Object.assign({}, r), { descriptionHtml: text }) : r) }) : null }))), placeholder: "<div>HTML \uCF58\uD150\uCE20...</div>", placeholderTextColor: "#999" }), _jsxs(FieldGroup, { style: { marginTop: 12 }, children: [_jsx(FieldLabel, { children: "\uBAA8\uBC14\uC77C Interactive \uC774\uBBF8\uC9C0 (@2x)" }), ((_a = route.interactiveImage) === null || _a === void 0 ? void 0 : _a.mobileUrl) ? (_jsxs(ImagePreviewContainer, { children: [_jsx(ImagePreview, { source: {
                                                                    uri: route.interactiveImage.mobileUrl,
                                                                } }), _jsx(ImageRemoveButton, { onPress: () => updateData((prev) => (Object.assign(Object.assign({}, prev), { routeSection: prev.routeSection
                                                                        ? Object.assign(Object.assign({}, prev.routeSection), { routes: prev.routeSection.routes.map((r, i) => i === routeIndex
                                                                                ? Object.assign(Object.assign({}, r), { interactiveImage: Object.assign(Object.assign({}, r.interactiveImage), { mobileUrl: undefined }) }) : r) }) : null }))), children: _jsx(ImageRemoveButtonText, { children: "\u00D7" }) })] })) : (_jsx(ImageUploader, { onUploadComplete: (url) => updateData((prev) => (Object.assign(Object.assign({}, prev), { routeSection: prev.routeSection
                                                                ? Object.assign(Object.assign({}, prev.routeSection), { routes: prev.routeSection.routes.map((r, i) => i === routeIndex
                                                                        ? Object.assign(Object.assign({}, r), { interactiveImage: Object.assign(Object.assign({}, r.interactiveImage), { mobileUrl: url }) }) : r) }) : null }))), buttonText: "\uBAA8\uBC14\uC77C \uC774\uBBF8\uC9C0 \uC5C5\uB85C\uB4DC" }))] })] }, route.id));
                                })] })), data.seatViewSection && (_jsxs(Section, { children: [_jsx(SectionTitle, { children: "\uC88C\uC11D \uBDF0 \uC139\uC158" }), _jsxs(SeatViewEditPanel, { children: [_jsxs(FieldGroup, { children: [_jsx(FieldLabel, { children: "\uD0C0\uC774\uD2C0" }), _jsx(FieldInput, { value: data.seatViewSection.title, onChangeText: (text) => updateData((prev) => (Object.assign(Object.assign({}, prev), { seatViewSection: prev.seatViewSection
                                                            ? Object.assign(Object.assign({}, prev.seatViewSection), { title: text }) : null }))), placeholder: "\uC608: \uC88C\uC11D \uC2DC\uC57C \uC548\uB0B4", placeholderTextColor: "#999" })] }), _jsxs(FieldGroup, { children: [_jsx(FieldLabel, { children: "Interactive \uC9C0\uB3C4 \uC774\uBBF8\uC9C0" }), ((_d = data.seatViewSection.interactiveImage) === null || _d === void 0 ? void 0 : _d.url) ? (_jsxs(ImagePreviewContainer, { children: [_jsx(ImagePreview, { source: { uri: data.seatViewSection.interactiveImage.url } }), _jsx(ImageRemoveButton, { onPress: () => updateData((prev) => (Object.assign(Object.assign({}, prev), { seatViewSection: prev.seatViewSection
                                                                    ? Object.assign(Object.assign({}, prev.seatViewSection), { interactiveImage: undefined }) : null }))), children: _jsx(ImageRemoveButtonText, { children: "\u00D7" }) })] })) : (_jsx(ImageUploader, { onUploadComplete: (url) => updateData((prev) => (Object.assign(Object.assign({}, prev), { seatViewSection: prev.seatViewSection
                                                            ? Object.assign(Object.assign({}, prev.seatViewSection), { interactiveImage: {
                                                                    url,
                                                                    clickableRegions: [],
                                                                } }) : null }))), buttonText: "\uC9C0\uB3C4 \uC774\uBBF8\uC9C0 \uC5C5\uB85C\uB4DC" }))] }), _jsxs(FieldGroup, { children: [_jsx(FieldLabel, { children: "\uBAA8\uBC14\uC77C Interactive \uC774\uBBF8\uC9C0 (@2x)" }), ((_e = data.seatViewSection.interactiveImage) === null || _e === void 0 ? void 0 : _e.mobileUrl) ? (_jsxs(ImagePreviewContainer, { children: [_jsx(ImagePreview, { source: {
                                                                uri: data.seatViewSection.interactiveImage.mobileUrl,
                                                            } }), _jsx(ImageRemoveButton, { onPress: () => updateData((prev) => (Object.assign(Object.assign({}, prev), { seatViewSection: prev.seatViewSection
                                                                    ? Object.assign(Object.assign({}, prev.seatViewSection), { interactiveImage: prev.seatViewSection.interactiveImage
                                                                            ? Object.assign(Object.assign({}, prev.seatViewSection.interactiveImage), { mobileUrl: undefined }) : undefined }) : null }))), children: _jsx(ImageRemoveButtonText, { children: "\u00D7" }) })] })) : (_jsx(ImageUploader, { onUploadComplete: (url) => updateData((prev) => (Object.assign(Object.assign({}, prev), { seatViewSection: prev.seatViewSection
                                                            ? Object.assign(Object.assign({}, prev.seatViewSection), { interactiveImage: prev.seatViewSection.interactiveImage
                                                                    ? Object.assign(Object.assign({}, prev.seatViewSection.interactiveImage), { mobileUrl: url }) : {
                                                                    url: '',
                                                                    clickableRegions: [],
                                                                    mobileUrl: url,
                                                                } }) : null }))), buttonText: "\uBAA8\uBC14\uC77C \uC774\uBBF8\uC9C0 \uC5C5\uB85C\uB4DC" }))] }), ((_f = data.seatViewSection.interactiveImage) === null || _f === void 0 ? void 0 : _f.url) && (_jsxs(FieldGroup, { children: [_jsx(FieldLabel, { children: "Regions" }), editingRegion && editingRegion.sectionType === 'seatView' ? (_jsxs(RegionEditPanel, { children: [_jsxs(RegionEditHeader, { children: [_jsx(RegionEditTitle, { children: editingRegion.regionIndex !== null
                                                                        ? `Region #${editingRegion.regionIndex + 1} 편집`
                                                                        : '새 Region 추가' }), _jsx(RegionRouteTag, { children: "SeatView" })] }), _jsx(RegionEditInfo, { children: _jsxs(InfoRow, { children: [_jsx(InfoLabel, { children: "\uC810 \uAC1C\uC218:" }), _jsxs(InfoValue, { children: [editingRegion.points.length, "\uAC1C"] })] }) }), _jsxs(RegionEditActions, { children: [_jsx(SmallButton, { onPress: clearRegionPoints, children: _jsx(SmallButtonText, { children: "\uCD08\uAE30\uD654" }) }), _jsx(SmallButton, { onPress: undoRegionPoint, disabled: editingRegion.pointsUndoStack.length === 0, style: {
                                                                        opacity: editingRegion.pointsUndoStack.length > 0 ? 1 : 0.5,
                                                                    }, children: _jsx(SmallButtonText, { children: "\u2318Z \uC2E4\uD589\uCDE8\uC18C" }) })] }), _jsxs(ModalImageSection, { children: [_jsxs(ModalImageLabel, { children: ["\uD074\uB9AD \uC2DC \uD45C\uC2DC\uD560 \uC774\uBBF8\uC9C0 (", editingRegion.modalImageUrls.length, "\uAC1C)"] }), _jsxs(ModalImageList, { children: [editingRegion.modalImageUrls.map((url, index) => (_jsxs(ModalImageItem, { children: [_jsx(TouchableOpacity, { onPress: () => setPreviewImageUrl(url), children: _jsx(ModalImagePreview, { source: { uri: url } }) }), _jsx(ModalImageRemove, { onPress: () => removeModalImageFromRegion(index), children: _jsx(ModalImageRemoveText, { children: "\u00D7" }) })] }, index))), _jsx(AddModalImageWrapper, { children: _jsx(ImageUploader, { onUploadComplete: addModalImageToRegion, buttonText: "+", compact: true }) })] })] }), _jsxs(RegionEditButtons, { children: [_jsx(CancelButton, { onPress: cancelEditingRegion, children: _jsx(CancelButtonText, { children: "\uCDE8\uC18C" }) }), _jsx(SaveButton, { onPress: saveEditingRegion, disabled: editingRegion.points.length < 3, style: {
                                                                        opacity: editingRegion.points.length >= 3 ? 1 : 0.5,
                                                                    }, children: _jsx(SaveButtonText, { children: "\uC800\uC7A5" }) })] })] })) : (_jsxs(_Fragment, { children: [_jsx(SeatViewRegionHeader, { children: _jsx(AddRegionButton, { onPress: startAddingSeatViewRegion, children: _jsx(AddRegionButtonText, { children: "+ Region \uCD94\uAC00" }) }) }), (data.seatViewSection.interactiveImage.clickableRegions || []).length > 0 ? ((data.seatViewSection.interactiveImage.clickableRegions || []).map((region, regionIndex) => {
                                                            var _a, _b, _c;
                                                            return (_jsxs(RegionListItem, { children: [_jsxs(RegionListHeader, { children: [_jsxs(RegionListInfo, { children: [_jsxs(RegionListIndex, { children: ["#", regionIndex + 1] }), _jsxs(RegionListDetail, { children: ["\uC810 ", region.polygon.length, "\uAC1C"] })] }), _jsxs(RegionListActions, { children: [_jsx(RegionEditButton, { onPress: () => startEditingSeatViewRegion(regionIndex, region.polygon, region.modalImageUrls || []), children: _jsx(RegionEditButtonText, { children: "\uD3B8\uC9D1" }) }), _jsx(RegionDeleteButton, { onPress: () => deleteSeatViewRegion(regionIndex), children: _jsx(RegionDeleteButtonText, { children: "\u00D7" }) })] })] }), ((_b = (_a = region.modalImageUrls) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 && (_jsx(RegionImageList, { children: (_c = region.modalImageUrls) === null || _c === void 0 ? void 0 : _c.map((url, imgIndex) => (_jsx(TouchableOpacity, { onPress: () => setPreviewImageUrl(url), children: _jsx(RegionImageThumb, { source: { uri: url } }) }, imgIndex))) }))] }, region.id));
                                                        })) : (_jsx(NoRegionsText, { children: "Region \uC5C6\uC74C" }))] }))] })), _jsxs(FieldGroup, { children: [_jsxs(FieldLabel, { children: ["\uC124\uBA85 HTML (", ((_g = data.seatViewSection.descriptionHtmls) === null || _g === void 0 ? void 0 : _g.length) || 0, "\uAC1C)"] }), (_h = data.seatViewSection.descriptionHtmls) === null || _h === void 0 ? void 0 : _h.map((html, index) => (_jsxs(HtmlEditRow, { children: [_jsx(HtmlTextAreaSmall, { multiline: true, value: html, onChangeText: (text) => updateData((prev) => {
                                                                var _a;
                                                                return (Object.assign(Object.assign({}, prev), { seatViewSection: prev.seatViewSection
                                                                        ? Object.assign(Object.assign({}, prev.seatViewSection), { descriptionHtmls: (_a = prev.seatViewSection.descriptionHtmls) === null || _a === void 0 ? void 0 : _a.map((h, i) => (i === index ? text : h)) }) : null }));
                                                            }), placeholder: "<div>HTML \uCF58\uD150\uCE20...</div>", placeholderTextColor: "#999" }), _jsx(HtmlRemoveButton, { onPress: () => updateData((prev) => {
                                                                var _a;
                                                                return (Object.assign(Object.assign({}, prev), { seatViewSection: prev.seatViewSection
                                                                        ? Object.assign(Object.assign({}, prev.seatViewSection), { descriptionHtmls: (_a = prev.seatViewSection.descriptionHtmls) === null || _a === void 0 ? void 0 : _a.filter((_, i) => i !== index) }) : null }));
                                                            }), children: _jsx(HtmlRemoveButtonText, { children: "\u00D7" }) })] }, index))), _jsx(AddHtmlButton, { onPress: () => updateData((prev) => (Object.assign(Object.assign({}, prev), { seatViewSection: prev.seatViewSection
                                                            ? Object.assign(Object.assign({}, prev.seatViewSection), { descriptionHtmls: [
                                                                    ...(prev.seatViewSection.descriptionHtmls || []),
                                                                    '',
                                                                ] }) : null }))), children: _jsx(AddHtmlButtonText, { children: "+ \uC124\uBA85 \uCD94\uAC00" }) })] })] })] })), data.nearbyPlacesSection && (_jsxs(Section, { children: [_jsx(SectionTitle, { children: "\uADFC\uCC98 \uC7A5\uC18C \uC139\uC158" }), _jsxs(NearbyPlacesEditPanel, { children: [_jsxs(FieldGroup, { children: [_jsx(FieldLabel, { children: "\uD0C0\uC774\uD2C0" }), _jsx(FieldInput, { value: data.nearbyPlacesSection.title, onChangeText: (text) => updateData((prev) => (Object.assign(Object.assign({}, prev), { nearbyPlacesSection: prev.nearbyPlacesSection
                                                            ? Object.assign(Object.assign({}, prev.nearbyPlacesSection), { title: text }) : null }))), placeholder: "\uC608: \uACE0\uCC99\uC2A4\uCE74\uC774\uB3D4 \uADFC\uCC98 \uB9DB\uC9D1 \uC815\uBCF4", placeholderTextColor: "#999" })] }), _jsxs(FieldGroup, { children: [_jsx(FieldLabel, { children: "\uC9C0\uB3C4 \uC774\uBBF8\uC9C0" }), data.nearbyPlacesSection.mapImageUrl ? (_jsxs(ImagePreviewContainer, { children: [_jsx(ImagePreview, { source: { uri: data.nearbyPlacesSection.mapImageUrl } }), _jsx(ImageRemoveButton, { onPress: () => updateData((prev) => (Object.assign(Object.assign({}, prev), { nearbyPlacesSection: prev.nearbyPlacesSection
                                                                    ? Object.assign(Object.assign({}, prev.nearbyPlacesSection), { mapImageUrl: '' }) : null }))), children: _jsx(ImageRemoveButtonText, { children: "\u00D7" }) })] })) : (_jsx(ImageUploader, { onUploadComplete: (url) => updateData((prev) => (Object.assign(Object.assign({}, prev), { nearbyPlacesSection: prev.nearbyPlacesSection
                                                            ? Object.assign(Object.assign({}, prev.nearbyPlacesSection), { mapImageUrl: url }) : null }))), buttonText: "\uC9C0\uB3C4 \uC774\uBBF8\uC9C0 \uC5C5\uB85C\uB4DC" }))] }), _jsxs(FieldGroup, { children: [_jsx(FieldLabel, { children: "\uBAA8\uBC14\uC77C \uC9C0\uB3C4 \uC774\uBBF8\uC9C0 (@2x)" }), data.nearbyPlacesSection.mobileMapImageUrl ? (_jsxs(ImagePreviewContainer, { children: [_jsx(ImagePreview, { source: { uri: data.nearbyPlacesSection.mobileMapImageUrl } }), _jsx(ImageRemoveButton, { onPress: () => updateData((prev) => (Object.assign(Object.assign({}, prev), { nearbyPlacesSection: prev.nearbyPlacesSection
                                                                    ? Object.assign(Object.assign({}, prev.nearbyPlacesSection), { mobileMapImageUrl: '' }) : null }))), children: _jsx(ImageRemoveButtonText, { children: "\u00D7" }) })] })) : (_jsx(ImageUploader, { onUploadComplete: (url) => updateData((prev) => (Object.assign(Object.assign({}, prev), { nearbyPlacesSection: prev.nearbyPlacesSection
                                                            ? Object.assign(Object.assign({}, prev.nearbyPlacesSection), { mobileMapImageUrl: url }) : null }))), buttonText: "\uBAA8\uBC14\uC77C \uC9C0\uB3C4 \uC774\uBBF8\uC9C0 \uC5C5\uB85C\uB4DC" }))] }), _jsxs(FieldGroup, { children: [_jsx(FieldLabel, { children: "\uB124\uC774\uBC84 \uB9AC\uC2A4\uD2B8 URL" }), _jsx(FieldInput, { value: data.nearbyPlacesSection.naverListUrl || '', onChangeText: (text) => updateData((prev) => (Object.assign(Object.assign({}, prev), { nearbyPlacesSection: prev.nearbyPlacesSection
                                                            ? Object.assign(Object.assign({}, prev.nearbyPlacesSection), { naverListUrl: text }) : null }))), placeholder: "https://map.naver.com/...", placeholderTextColor: "#999" })] }), _jsxs(FieldGroup, { children: [_jsx(FieldLabel, { children: "\uB354 \uB9CE\uC740 \uC7A5\uC18C URL" }), _jsx(FieldInput, { value: data.nearbyPlacesSection.morePlacesUrl || '', onChangeText: (text) => updateData((prev) => (Object.assign(Object.assign({}, prev), { nearbyPlacesSection: prev.nearbyPlacesSection
                                                            ? Object.assign(Object.assign({}, prev.nearbyPlacesSection), { morePlacesUrl: text }) : null }))), placeholder: "https://...", placeholderTextColor: "#999" })] }), _jsx(DeleteSectionButton, { onPress: () => updateData((prev) => (Object.assign(Object.assign({}, prev), { nearbyPlacesSection: null }))), children: _jsx(DeleteSectionButtonText, { children: "\uC139\uC158 \uC0AD\uC81C" }) })] })] })), _jsxs(Section, { children: [_jsx(SectionTitle, { children: "JSON Export" }), _jsx(ActionButton, { onPress: handleExportJson, children: _jsx(ActionButtonText, { children: copySuccess ? '✓ 복사됨!' : '📋 JSON 복사' }) })] }), _jsxs(Section, { children: [_jsx(SectionTitle, { children: "JSON Import" }), _jsx(JsonTextArea, { multiline: true, value: jsonInput, onChangeText: setJsonInput, placeholder: "JSON\uC744 \uC5EC\uAE30\uC5D0 \uBD99\uC5EC\uB123\uC73C\uC138\uC694...", placeholderTextColor: "#999" }), importError && _jsx(ErrorText, { children: importError }), _jsx(ActionButton, { onPress: handleImportJson, disabled: !jsonInput.trim(), style: { opacity: jsonInput.trim() ? 1 : 0.5 }, children: _jsx(ActionButtonText, { children: "Import" }) })] }), _jsxs(Section, { children: [_jsx(SectionTitle, { children: "\uB2E8\uCD95\uD0A4" }), _jsx(HelpText, { children: "\u2022 Polygon \uD3B8\uC9D1 \uC911 \u2318Z: \uC810 \uCDE8\uC18C" })] })] }) }), _jsx(RegionDetailModal, { visible: !!previewImageUrl, region: previewRegion, onClose: () => setPreviewImageUrl(null) })] }));
}
const Container = styled(View) `
  width: 320px;
  background-color: #f8f9fa;
  border-left-width: 1px;
  border-left-color: #e0e0e0;
`;
const SidebarContent = styled(View) `
  padding: 20px;
`;
const Header = styled(View) `
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom-width: 1px;
  border-bottom-color: #e0e0e0;
`;
const HeaderTitle = styled(Text) `
  font-size: 20px;
  font-weight: 700;
  color: #333;
`;
const EditBadge = styled(View) `
  background-color: #007aff;
  padding: 4px 8px;
  border-radius: 4px;
`;
const EditBadgeText = styled(Text) `
  font-size: 12px;
  font-weight: 600;
  color: #fff;
`;
const Section = styled(View) `
  margin-bottom: 24px;
`;
const SectionTitle = styled(Text) `
  font-size: 14px;
  font-weight: 600;
  color: #666;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;
const InfoRow = styled(View) `
  flex-direction: row;
  margin-bottom: 8px;
`;
const InfoLabel = styled(Text) `
  font-size: 14px;
  color: #666;
  width: 80px;
`;
const InfoValue = styled(Text) `
  font-size: 14px;
  color: #333;
  flex: 1;
`;
const ActionButton = styled(TouchableOpacity) `
  background-color: #007aff;
  padding: 12px 16px;
  border-radius: 8px;
  align-items: center;
`;
const ActionButtonText = styled(Text) `
  font-size: 14px;
  font-weight: 600;
  color: #fff;
`;
const JsonTextArea = styled(TextInput) `
  background-color: #fff;
  border-width: 1px;
  border-color: #ddd;
  border-radius: 8px;
  padding: 12px;
  min-height: 120px;
  font-size: 12px;
  font-family: monospace;
  margin-bottom: 12px;
  text-align-vertical: top;
`;
const ErrorText = styled(Text) `
  font-size: 12px;
  color: #dc3545;
  margin-bottom: 8px;
`;
const HelpText = styled(Text) `
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
`;
const LoginStatusRow = styled(View) `
  flex-direction: row;
  align-items: center;
  margin-bottom: 12px;
`;
const LoginStatusIcon = styled(Text) `
  font-size: 16px;
  font-weight: 700;
  color: #28a745;
  margin-right: 8px;
`;
const LoginStatusText = styled(Text) `
  font-size: 14px;
  color: #333;
  flex: 1;
`;
const KakaoLoginButton = styled(TouchableOpacity) `
  background-color: #fee500;
  padding: 12px 16px;
  border-radius: 8px;
  align-items: center;
`;
const KakaoLoginButtonText = styled(Text) `
  font-size: 14px;
  font-weight: 600;
  color: #3c1e1e;
`;
const LogoutButton = styled(TouchableOpacity) `
  background-color: #6c757d;
  padding: 10px 16px;
  border-radius: 8px;
  align-items: center;
`;
const LogoutButtonText = styled(Text) `
  font-size: 14px;
  font-weight: 600;
  color: #fff;
`;
// Region 편집 관련 스타일
const RegionEditPanel = styled(View) `
  background-color: #fff;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #007aff;
`;
const RegionEditHeader = styled(View) `
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;
const RegionEditTitle = styled(Text) `
  font-size: 15px;
  font-weight: 600;
  color: #333;
`;
const RegionRouteTag = styled(Text) `
  font-size: 11px;
  color: #007aff;
  background-color: #e8f4ff;
  padding: 2px 6px;
  border-radius: 4px;
`;
const RegionEditInfo = styled(View) `
  margin-bottom: 12px;
`;
const RegionEditActions = styled(View) `
  flex-direction: row;
  gap: 8px;
  margin-bottom: 12px;
`;
const SmallButton = styled(TouchableOpacity) `
  flex: 1;
  padding: 8px;
  background-color: #f0f0f0;
  border-radius: 6px;
  align-items: center;
`;
const SmallButtonText = styled(Text) `
  font-size: 12px;
  color: #333;
`;
const ModalImageSection = styled(View) `
  margin-bottom: 12px;
`;
const ModalImageLabel = styled(Text) `
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
`;
const ModalImageList = styled(View) `
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;
const ModalImageItem = styled(View) `
  position: relative;
`;
const ModalImagePreview = styled(Image) `
  width: 50px;
  height: 50px;
  border-radius: 4px;
  background-color: #f0f0f0;
`;
const ModalImageRemove = styled(TouchableOpacity) `
  position: absolute;
  top: -6px;
  right: -6px;
  width: 18px;
  height: 18px;
  border-radius: 9px;
  background-color: #dc3545;
  align-items: center;
  justify-content: center;
`;
const ModalImageRemoveText = styled(Text) `
  color: #fff;
  font-size: 12px;
  font-weight: 700;
`;
const AddModalImageWrapper = styled(View) `
  justify-content: center;
`;
const RegionEditButtons = styled(View) `
  flex-direction: row;
  gap: 8px;
`;
const CancelButton = styled(TouchableOpacity) `
  flex: 1;
  padding: 10px;
  background-color: #f0f0f0;
  border-radius: 6px;
  align-items: center;
`;
const CancelButtonText = styled(Text) `
  font-size: 13px;
  font-weight: 600;
  color: #666;
`;
const SaveButton = styled(TouchableOpacity) `
  flex: 1;
  padding: 10px;
  background-color: #007aff;
  border-radius: 6px;
  align-items: center;
`;
const SaveButtonText = styled(Text) `
  font-size: 13px;
  font-weight: 600;
  color: #fff;
`;
const RouteRegionSection = styled(View) `
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
`;
const RouteRegionHeader = styled(View) `
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;
const RouteRegionTitle = styled(Text) `
  font-size: 13px;
  font-weight: 600;
  color: #333;
`;
const AddRegionButton = styled(TouchableOpacity) `
  padding: 4px 8px;
  background-color: #007aff;
  border-radius: 4px;
`;
const AddRegionButtonText = styled(Text) `
  font-size: 11px;
  font-weight: 600;
  color: #fff;
`;
const RegionListItem = styled(View) `
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 6px;
  margin-bottom: 6px;
`;
const RegionListHeader = styled(View) `
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const RegionListInfo = styled(View) `
  flex-direction: row;
  align-items: center;
  flex: 1;
`;
const RegionListIndex = styled(Text) `
  font-size: 13px;
  font-weight: 700;
  color: #007aff;
  width: 30px;
`;
const RegionListDetail = styled(Text) `
  font-size: 12px;
  color: #666;
`;
const RegionListActions = styled(View) `
  flex-direction: row;
  gap: 6px;
`;
const RegionEditButton = styled(TouchableOpacity) `
  padding: 4px 10px;
  background-color: #007aff;
  border-radius: 4px;
`;
const RegionEditButtonText = styled(Text) `
  font-size: 11px;
  font-weight: 600;
  color: #fff;
`;
const RegionDeleteButton = styled(TouchableOpacity) `
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background-color: #dc3545;
  align-items: center;
  justify-content: center;
`;
const RegionDeleteButtonText = styled(Text) `
  color: #fff;
  font-size: 14px;
  font-weight: 700;
`;
const NoRegionsText = styled(Text) `
  font-size: 12px;
  color: #999;
  font-style: italic;
`;
const RegionImageList = styled(View) `
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
`;
const RegionImageThumb = styled(Image) `
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background-color: #e0e0e0;
`;
// NearbyPlacesSection 편집 스타일
const NearbyPlacesEditPanel = styled(View) `
  background-color: #fff;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #e0e0e0;
`;
const FieldGroup = styled(View) `
  margin-bottom: 16px;
`;
const FieldLabel = styled(Text) `
  font-size: 12px;
  font-weight: 600;
  color: #666;
  margin-bottom: 6px;
`;
const FieldInput = styled(TextInput) `
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 14px;
  color: #333;
`;
const ImagePreviewContainer = styled(View) `
  position: relative;
  width: 100%;
`;
const ImagePreview = styled(Image) `
  width: 100%;
  height: 120px;
  border-radius: 6px;
  background-color: #f0f0f0;
`;
const ImageRemoveButton = styled(TouchableOpacity) `
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background-color: #dc3545;
  align-items: center;
  justify-content: center;
`;
const ImageRemoveButtonText = styled(Text) `
  color: #fff;
  font-size: 16px;
  font-weight: 700;
`;
const DeleteSectionButton = styled(TouchableOpacity) `
  margin-top: 8px;
  padding: 10px;
  background-color: #dc3545;
  border-radius: 6px;
  align-items: center;
`;
const DeleteSectionButtonText = styled(Text) `
  font-size: 13px;
  font-weight: 600;
  color: #fff;
`;
// Route HTML 편집 스타일
const RouteHtmlEditPanel = styled(View) `
  background-color: #fff;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #e0e0e0;
`;
const RouteHtmlHeader = styled(View) `
  margin-bottom: 8px;
`;
const RouteHtmlTitle = styled(Text) `
  font-size: 13px;
  font-weight: 600;
  color: #333;
`;
const HtmlTextArea = styled(TextInput) `
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 10px 12px;
  min-height: 150px;
  font-size: 12px;
  font-family: monospace;
  color: #333;
  text-align-vertical: top;
`;
// SeatViewSection 편집 스타일
const SeatViewEditPanel = styled(View) `
  background-color: #fff;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #e0e0e0;
`;
const HtmlEditRow = styled(View) `
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 8px;
  gap: 8px;
`;
const HtmlTextAreaSmall = styled(TextInput) `
  flex: 1;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 8px 10px;
  min-height: 80px;
  font-size: 11px;
  font-family: monospace;
  color: #333;
  text-align-vertical: top;
`;
const HtmlRemoveButton = styled(TouchableOpacity) `
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background-color: #dc3545;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
`;
const HtmlRemoveButtonText = styled(Text) `
  color: #fff;
  font-size: 14px;
  font-weight: 700;
`;
const AddHtmlButton = styled(TouchableOpacity) `
  padding: 8px 12px;
  background-color: #007aff;
  border-radius: 6px;
  align-items: center;
  margin-top: 4px;
`;
const AddHtmlButtonText = styled(Text) `
  font-size: 12px;
  font-weight: 600;
  color: #fff;
`;
const SeatViewRegionHeader = styled(View) `
  margin-bottom: 8px;
`;
const HeaderEditPanel = styled(View) `
  background-color: #fff;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #e0e0e0;
`;
const OgImagePreview = styled(View) `
  margin-top: 8px;
  border-radius: 6px;
  overflow: hidden;
  background-color: #f0f0f0;
`;
const OgImagePreviewImg = styled(Image) `
  width: 100%;
  height: 100px;
`;
